import * as apiroutes from '../apiRoutes'
import localStorageService from './localStorageService'
import { getEnv } from '../envConfig'

class FileServices {


    /**
     * Fetch image blob from upload path with authorization
     * @param {string} imagePath - Relative path from uploads directory (e.g., "categories/uuid/filename.jpg")
     * @returns {Promise<Blob>} Image blob data
     * @throws {Error} If image fetch fails
     */
    static async getImageBlob(imagePath) {
        try {
            if (!imagePath) {
                throw new Error('Image path is required');
            }

            const accessToken = await localStorageService.getItem('access_token');
            const env = getEnv();
            const imageUrl = `${env.ENDPOINT}${apiroutes.IMAGE_UPLOAD_PATH}/${imagePath}`;

            console.log('Fetching image from:', imageUrl);

            const response = await fetch(imageUrl, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Accept': 'image/webp,image/avif,image/apng,image/svg+xml,image/*,*/*;q=0.8'
                }
            });

            if (!response.ok) {
                console.error('Image fetch failed:', {
                    status: response.status,
                    statusText: response.statusText,
                    url: imageUrl
                });
                throw new Error(`Failed to fetch image: ${response.status} ${response.statusText}`);
            }

            const blob = await response.blob();

            console.log('Image blob details:', {
                size: blob.size,
                type: blob.type,
                path: imagePath
            });

            // Verify we received an image
            if (!blob.type.startsWith('image/')) {
                console.warn('Received non-image content-type:', blob.type);
                // For WebP files, some servers might not set correct content-type
                if (imagePath.toLowerCase().endsWith('.webp')) {
                    console.log('Assuming WebP format based on file extension');
                    // Create a new blob with correct type
                    return new Blob([blob], { type: 'image/webp' });
                }
                throw new Error(`Invalid content type: ${blob.type}`);
            }

            return blob;
        } catch (error) {
            console.error('Error fetching image blob:', error);
            throw error;
        }
    }
}
export default FileServices


//     static async getAnalysistImage(name) {
//         try {
//             if (name) {
//                 const accessToken = await localStorageService.getItem('access_token')

//                 const response = await fetch(`${apiroutes.INCIDENT_ANALYSIS}/preview/${name}`, { headers: { Authorization: `Bearer ${accessToken}` } })
//                 if (!response.ok) {
//                     throw new Error('Failed to fetch image')
//                 }

//                 return window.URL.createObjectURL(await response.blob())

//             } else {
//                 return '/assets/siteLogo/logo.png'

//             }
//         } catch (error) {
//             return '/assets/images/no-header-img.jpg'
//         }


//     }


// }

// export default FileServices